import { render, staticRenderFns } from "./vendorMainIndex.vue?vue&type=template&id=30c556d5"
import script from "./vendorMainIndex.vue?vue&type=script&lang=js"
export * from "./vendorMainIndex.vue?vue&type=script&lang=js"
import style0 from "./vendorMainIndex.vue?vue&type=style&index=0&id=30c556d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports